export default "__VITE_ASSET__DcBUyG04__"